import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  CheckCircleIcon,
  XCircleIcon,
  ExclamationTriangleIcon,
  ClockIcon,
  QuestionMarkCircleIcon,
} from '@heroicons/react/20/solid'; // You can also use /24 or /outline
import { formatStatusKey } from '../TestLaunchDetail/statusColorPallete';

export default function TestGroupStatusBadge({ status }) {

  // status = status.length > 0 ? status : {
  //   passed: 1,
  //   failed: 2,
  //   pending: 3,
  //   overall: 'Passed',
  // };

  let IconComponent = QuestionMarkCircleIcon;
  let iconColor = '#64748b'; // slate-500 default

  switch (status.overall) {
    case 'passed':
      IconComponent = CheckCircleIcon;
      iconColor = '#16a34a'; // Tailwind green-600
      break;
    case 'failed':
      IconComponent = XCircleIcon;
      iconColor = '#dc2626'; // Tailwind red-600
      break;
    case 'mixed':
    case 'in_progress':
      IconComponent = ExclamationTriangleIcon;
      iconColor = '#f59e0b'; // Tailwind yellow-500
      break;
    case 'pending':
      IconComponent = ClockIcon;
      iconColor = '#facc15'; // Tailwind yellow-400
      break;
    default:
      IconComponent = QuestionMarkCircleIcon;
      iconColor = '#64748b';
  }

  const capitalizeWords = (str) => {
    if (!str) return str;
    return str.split(/[_\s]+/).map(word => 
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    ).join(' ');
  };

  const statusString = Object.entries(status).map(([key, value]) => {
    if(key === 'overall') {
      return `${capitalizeWords(key)}: ${capitalizeWords(value)}`;
    }
    return `${value} ${capitalizeWords(key)}`;
  }).join(', ')

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <IconComponent style={{ color: iconColor, width: 18, height: 18, marginRight: 4 }} />
      <Box display="flex" flexDirection="column" title={statusString}>
        <Box display="flex" gap={1}>
          {status.passed > 0 && (
            <Typography variant="caption" sx={{ color: '#16a34a', fontWeight: 500 }}>
              {status.passed} Passed
            </Typography>
          )}
          {status.failed > 0 && (
            <Typography variant="caption" sx={{ color: '#dc2626', fontWeight: 500 }}>
              {status.failed} Failed
            </Typography>
          )}
          {status.pending > 0 && (
            <Typography variant="caption" sx={{ color: '#f59e0b', fontWeight: 500 }}>
              {status.pending} Pending
            </Typography>
          )}
        </Box>
        <Typography variant="caption" color="text.secondary">
          {
            status.overall ? (
              <Typography variant="caption" color="text.secondary">
                Overall: {formatStatusKey(status.overall)}
              </Typography>
            ) : (
              <Typography variant="caption" color="text.secondary">
                Not Executed
              </Typography>
            )
          }
        </Typography>
      </Box>
    </Box>
  );
}
